import "@arco-design/web-react/es/Select/style";
import _Select from "@arco-design/web-react/es/Select";
import { useSelect as useProject } from '@/pages/activityRoomConfig/api';
import React from 'react';
export const SelectRoom = ({
  value,
  onChange,
  mode,
  placeholder = '全部'
}) => {
  const {
    data,
    isLoading
  } = useProject({
    params: {
      pageSize: 100,
      pageIndex: 1
    }
  });
  const items = data?.data.items ?? [];
  return /*#__PURE__*/React.createElement(_Select, {
    mode: mode,
    value: value,
    onChange: onChange,
    placeholder: placeholder,
    loading: isLoading,
    options: items.map(v => ({
      label: `${v.id}:${v.name}`,
      value: v.id
    })),
    allowClear: true
  });
};